import CookiesPopup from 'components/atoms/cookies/CookiesPopup';
import i18n from 'locales/i18n';
import { HelmetProvider } from 'react-helmet-async';
import toast, { ToastBar, Toaster } from 'react-hot-toast';
import { I18nextProvider } from 'react-i18next';
import { IChildrenProp } from 'types/components/components.interface';
import { toastOptions } from 'utils';
import AppInfoProvider from './AppInfoProvider';
import { ConnectionProvider } from './ConnectionContext';
import { PlayerProvider } from './PlayerProvider';
import QueryProvider from './QueryProvider';
import { StoreStateProvider } from './StoreStateContext';
import ThemeProvider from './ThemeProvider';

interface IAppProvidersProps extends IChildrenProp {}

const AppProviders = ({ children }: IAppProvidersProps) => {
  return (
    <StoreStateProvider>
      <QueryProvider>
        <ThemeProvider>
          <AppInfoProvider>
            <ConnectionProvider>
              <PlayerProvider>
                <I18nextProvider i18n={i18n}>
                  <Toaster
                    position='bottom-right'
                    reverseOrder={false}
                    gutter={10}
                    containerClassName='toast-wrapper'
                    containerStyle={{ inset: 30 }}
                    toastOptions={toastOptions}>
                    {t => (
                      <div onClick={() => toast.dismiss(t.id)}>
                        <ToastBar toast={t} />
                      </div>
                    )}
                  </Toaster>

                  <CookiesPopup />
                  <HelmetProvider>{children}</HelmetProvider>
                </I18nextProvider>
              </PlayerProvider>
            </ConnectionProvider>
          </AppInfoProvider>
        </ThemeProvider>
      </QueryProvider>
    </StoreStateProvider>
  );
};

export default AppProviders;
